import React from 'react';
import { connect } from 'react-redux';

const WithApa = WrappedComponent => {
  const HocComponent = props => <WrappedComponent {...props} />;

  const mapStateToProps = state => ({
    asset: state.asset,
    metadata: state.metadata,
    translations: state.translations,
  });

  return connect(mapStateToProps)(HocComponent);
};

export default WithApa;
